"use client";

import { useRef, useState, useEffect } from "react";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

// Icônes Solar, comme partout ailleurs sur la plateforme. Variante au trait :
// ce sont des filtres, pas des accents, et un seul élément doit ressortir, celui
// qui est actif.
const categories = [
    {
        id: "all",
        icon: null,
    },
    {
        id: "developers",
        icon: "programming-linear",
    },
    {
        id: "entrepreneurs",
        icon: "case-minimalistic-linear",
    },
    {
        id: "nocode",
        icon: "bolt-linear",
    },
];

export default function CoursesCategoryFilter({ category, level }) {
    const t = useTranslations();
    const scrollRef = useRef(null);
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);

    const handleScroll = (e) => {
        const { scrollLeft, scrollWidth, clientWidth } = e.target;
        setIsAtStart(scrollLeft === 0);
        setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
    };

    useEffect(() => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            setIsAtStart(scrollLeft === 0);
            setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
        }
    }, []);

    return (
        <div
            className={`gradient-wrapper relative mt-4 ${
                isAtStart ? "hide-left" : ""
            } ${isAtEnd ? "hide-right" : ""}`}
        >
            <div
                ref={scrollRef}
                onScroll={handleScroll}
                className="flex gap-2 overflow-x-auto pb-2 relative"
                style={{ scrollbarWidth: "none" }}
            >
                {categories.map((cat) => {
                    const isActive = category === cat.id || (!category && cat.id === "all");

                    return (
                        // Même correction que dans CoursesTabs : le lien porte
                        // l'apparence, il n'enveloppe plus un bouton.
                        <Link
                            key={cat.id}
                            href={{
                                pathname: "/courses",
                                query: {
                                    level: level || "discover",
                                    ...(cat.id !== "all" && { category: cat.id }),
                                },
                            }}
                            aria-current={isActive ? "page" : undefined}
                            className={`
                                flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm
                                transition-all duration-200 whitespace-nowrap
                                ${
                                    isActive
                                        ? "bg-primary !text-white shadow-md shadow-primary/25"
                                        : "bg-gray-100 dark:bg-white/5 text-gray-700 dark:text-grayDark-300 hover:bg-gray-200 dark:hover:bg-white/10"
                                }
                            `}
                        >
                            {cat.icon && <SolarIcon name={cat.icon} className="w-4 h-4" />}
                            <span>{t(`courses_category_${cat.id}`)}</span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
